<div class="partner-bg">
    <div class="">
        <br />
        <br />
        <br />

        <!--<ngb-carousel style="z-index: 0;" *ngIf="slides" [showNavigationArrows]="true" [showNavigationIndicators]="true">
            <ng-template ngbSlide *ngFor="let slide of slides">
                <div class="slide-container mb-2" [style]="{'background-image': 'url(' + slide.image + ')'}">
                    <div class="ver-airs">
                        <button class="btn btn-block btn-warning">
                            {{slide.btnText}}
                        </button>
                    </div>
                </div>  class="picture-slides"
            </ng-template>
        </ngb-carousel>-->

<!--        <div class="mt-4" (mouseenter)="pauseAnimation()" (mouseleave)="resumeAnimation()">-->
        <div class="mt-4">
            <div>
<!--            <div class="scroll-content">-->
                <div class="m-3" style="width: 100% !important;">
                    <div class="d-flex flex-column justify-content-center align-items-center">
                        <img src="assets/landing/soludo-chuks.png" style="width: 300px;height: 360px;border-radius: 10px;margin-bottom: 20px" alt="" />
                        <h6 class="text-center header-names fs-4">H.E Chukwuma C. Soludo CFR</h6>
                        <small class="text-center">Executive Governor, Anambra State</small>
                    </div>
                </div>
<!--                <div class="m-3" style="width: 100% !important;">-->
<!--                    <div class="d-flex flex-column justify-content-center align-items-center">-->
<!--                        <img src="assets/landing/greg-ezeilo.png" style="width: 320px;height: 360px;border-radius: 10px;margin-bottom: 20px" alt="" />-->
<!--                        <h6 class="text-center header-names fs-4">Dr Ezeilo Greg</h6>-->
<!--                        <small class="text-center">Executive Chairman, AIRS  </small>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="m-3" style="width: 100% !important;">-->
<!--                    <div class="d-flex flex-column justify-content-center align-items-center">-->
<!--                        <img src="assets/landing/mr-ben-okafor.jpeg" style="width: 300px;height: 360px;border-radius: 10px;margin-bottom: 20px" alt="" />-->
<!--                        <h6 class="text-center header-names fs-4">Mr Ben Okafor</h6>-->
<!--                        <small class="text-center">Executive Director Assessment</small>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="m-3" style="width: 100% !important;">-->
<!--                    <div class="d-flex flex-column justify-content-center align-items-center">-->
<!--                        <img src="assets/landing/1696665281212.jpeg" style="width: 300px;height: 360px;border-radius: 10px;margin-bottom: 20px" alt="" />-->
<!--                        <h6 class="text-center header-names fs-4">Mrs Oyeka Amara Kate FCA</h6>-->
<!--                        <small class="text-center">SSA on IGR (Technical)</small>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="m-3" style="width: 100% !important;">-->
<!--                    <div class="d-flex flex-column justify-content-center align-items-center">-->
<!--                        <img src="assets/img/ofomata.jpg" style="width: 300px;height: 360px;border-radius: 10px;margin-bottom: 20px" alt="" />-->
<!--                        <h6 class="text-center header-names fs-4">Mr. Herbert Chika Ofomata</h6>-->
<!--                        <small class="text-center">Head of Direct Assessment Tax</small>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="m-3" style="width: 100% !important;">-->
<!--                    <div class="d-flex flex-column justify-content-center align-items-center">-->
<!--                        <img src="assets/img/chika.jpg" style="width: 300px;height: 360px;border-radius: 10px;margin-bottom: 20px" alt="" />-->
<!--                        <h6 class="text-center header-names fs-4">Mrs. Chika Obiano</h6>-->
<!--                        <small class="text-center"> Head of PAYE (AIRS)</small>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="m-3" style="width: 100% !important;">-->
<!--                    <div class="d-flex flex-column justify-content-center align-items-center">-->
<!--                        <img src="assets/img/chuks.jpg" style="width: 300px;height: 360px;border-radius: 10px;margin-bottom: 20px" alt="" />-->
<!--                        <h6 class="text-center header-names fs-4">Mr. Udeh Edwin Chukwuma</h6>-->
<!--                        <small class="text-center">Head of ICT</small>-->
<!--                    </div>-->
<!--                </div>-->
<!--                <div class="m-3" style="width: 100% !important;">-->
<!--                    <div class="d-flex flex-column justify-content-center align-items-center">-->
<!--                        <img src="assets/img/emeka.jpg" style="width: 300px;height: 360px;border-radius: 10px;margin-bottom: 20px" alt="" />-->
<!--                        <h6 class="text-center header-names fs-4"> Mr. Emeka Anyaneto</h6>-->
<!--                        <small class="text-center">Head of CGT (AIRS)</small>-->
<!--                    </div>-->
<!--                </div>-->
            </div>
        </div>

        <br /><br />

        <div class="row partner-container p-3">
            <h2>Our Partners</h2>
            <p>We operate more efficiently by making strategic partnerships</p>
            <br />
            <div class="mb-4 mt-3 text-center">
                <img src="/assets/partners/jtb.svg" class="mx-3" height="48" width="78" alt="">
                <img src="/assets/partners/firs.svg" class="mx-3" height="48" width="78" alt="">
                <img src="/assets/partners/coat.svg" class="mx-3" height="48" width="78" alt="">
                <img src="/assets/partners/remita.svg" class="mx-3" height="48" width="78" alt="">
                <img src="/assets/partners/oasis.svg" class="mx-3" height="48" width="78" alt="">
                <img src="/assets/partners/nibzz.svg" class="mx-3" height="48" width="78" alt="">
            </div>
        </div>
        <br />

    </div>
</div>
